module.exports = __webpack_public_path__ + "img/right_white.00a7cf2.png";